import viLocale from 'element-ui/lib/locale/lang/vi' //引入element语言包
const vi = {
  Login: {
    ToLogin: 'Đăng nhập',
    PhoneLogin: 'Số điện thoại Đăng nhập',
    EmailLogin: 'Đăng nhập hộp thư',
    PhonePlaceholder: 'Vui lòng nhập số điện thoại',
    EmailPlaceholder: 'Enter email',
    Code: 'Mã xác nhận',
    and: 'Và',
    BeforeText: 'Tạo tài khoản thay mặt bạn đồng ý và tuân thủ',
    UserAgreement: 'Thỏa thuận người dùng',
    privacy: 'Chính sách bảo mật',
    errorMessage: 'Lỗi CAPTCHA',
    readTitle: 'Đọc và đồng ý với thỏa thuận sau',
    readBefore: 'Để giữ thông tin cá nhân của bạn an toàn, vui lòng đọc và đồng ý trước',
    cancel: 'Hủy bỏ',
    agree: 'Đồng ý và tiếp tục',
    error1:'Vui lòng nhập địa chỉ hộp thư hợp lệ',
    error2:'Vui lòng nhập đúng số điện thoại',
    error3:'Vui lòng nhập CAPTCHA',
    success:'Đăng nhập thành công'
  },
  ...viLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default vi;
